/** Picks the plural form of a message for a count, by the rendered language. */
import { activeLocaleTag } from "./runtime";
import type { PluralForms } from "./types";

const rulesByLocale = new Map<string, Intl.PluralRules>();

function pluralRules(locale: string): Intl.PluralRules {
  let rules = rulesByLocale.get(locale);
  if (!rules) {
    rules = new Intl.PluralRules(locale);
    rulesByLocale.set(locale, rules);
  }
  return rules;
}

/** `count === 0` uses an explicit `zero` form when the message has one
 *  ("No files"), whatever the language's rules say. */
export function selectPluralForm(forms: PluralForms, count: number): string {
  if (count === 0 && forms.zero !== undefined) return forms.zero;
  const category = pluralRules(activeLocaleTag()).select(
    count,
  ) as keyof PluralForms;
  return forms[category] ?? forms.other;
}
